const loggingEnabled = () => {
    return (/debugads=([^;]*)/.test(document.cookie) ||
        (typeof window !== 'undefined' && window.location.search.includes('debugads=true')));
};
const log = (...args) => {
    if (loggingEnabled()) {
        console.log(...args);
    }
};
export default { log };
//# sourceMappingURL=logger.js.map